import styled from 'styled-components/native'

export const SuccessGif = styled.Image`
  width: 128px;
  height: 128px;
  margin-left: calc(50% - 64px);
`